// DataDeletionModal.js
import React from "react";
import Modal from "react-bootstrap/Modal";
import '../../_css/ConfirmDeleteModal.css'

const formatTimestamp = (timestamp) => {
    if (!timestamp) return '';
    const date = new Date(timestamp);

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    return `${day} ${month} ${year}`;
};

const DataDeletionModal = ({ show, onHide, data, onApprove, onDeny }) => {
    if (!data) return null;
    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            dialogClassName="custom-deletion-modal"
        >
            <Modal.Header closeButton className="no-border">
                <Modal.Title style={{ fontWeight: 600, font: 'Clash Display', fontSize: '20px', lineHeight: "28px", border: 'none' }}>
                    Data Deletion Request
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                    {[
                        { label: "Request ID", key: "requestId" },
                        { label: "Requested By", key: "requestedBy" },
                        { label: "Requested On", key: "dateRequested", isDate: true },
                        { label: "Type", key: "type" },
                        { label: "Status", key: "status" }
                    ].map(({ label, key, isDate }) => (
                        <div key={key} style={{ display: "flex", justifyContent: "space-between" }}>
                            <div style={{ display: "flex", width: "100%" }}>
                                <div style={{ width: '142px' }}>
                                    <span style={{
                                        fontWeight: 700,
                                        lineHeight: "24px",
                                        fontFamily: 'Plus Jakarta Sans, sans-serif',
                                        fontSize: "16px",
                                        color: '#4B5563'
                                    }}>
                                        {label}
                                    </span>
                                </div>
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {key === "status" ? (
                                        <span
                                            style={{
                                                backgroundColor: "#E5E7EB",
                                                color: "#4B5563",
                                                borderRadius: "20px",
                                                padding: "4px 12px",
                                                fontSize: "14px",
                                                fontWeight: 500,
                                                // border: "1px solid #23B4C3",
                                                textTransform: "capitalize",
                                            }}
                                        >
                                            {data[key] || "-"}
                                        </span>
                                    ) : (
                                        <span style={{ fontSize: "16px", textAlign: "right", fontWeight: '400', color: '#4B5563' }}>
                                            {isDate ? formatTimestamp(data[key]) : data[key] || "-"}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </Modal.Body>
            <Modal.Footer className="justify-content-start align-item-center">
                <button className="modal-btn-outline" onClick={() => onDeny(data)}>Deny</button>
                <button className="modal-btn" onClick={() => onApprove(data)}>Approve</button>
            </Modal.Footer>
        </Modal>
    );
};


export default DataDeletionModal;
